<template>
  <div class="forum-wrapper">
    <div class="forum-layout">
      <div class="main-column">
        <header class="admin-header">
          <h1 class="typo-headline-4">Reportes Pendientes</h1>
        </header>
        <div class="admin-content">
          <p class="coming-soon">Funcionalidad en desarrollo. Estará disponible próximamente.</p>
        </div>
      </div>
      <div class="side-column">
        <user-activity-widget />
        <navigation-links />
      </div>
    </div>
  </div>
</template>

<script>
import UserActivityWidget from '../components/UserActivityWidget.vue';
import NavigationLinks from '../components/NavigationLinks.vue';

export default {
  name: 'AdminReports',
  components: {
    UserActivityWidget,
    NavigationLinks
  }
};
</script>

<style scoped>
.forum-wrapper {
  background-color: var(--color-background);
  min-height: 100vh;
  padding: 40px 20px;
}

.forum-layout {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  gap: 20px;
}

.main-column {
  flex: 3;
  color: var(--color-text-primary);
}

.side-column {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.admin-header {
  margin-bottom: 20px;
  padding: 20px;
  background-color: var(--color-surface);
  border-radius: 15px 15px 0 0;
  text-align: center;
}

.admin-header h1 {
  margin: 0;
}

.admin-content {
  background-color: var(--color-surface);
  padding: 20px;
  border-radius: 0 0 15px 15px;
  text-align: center;
}

.coming-soon {
  padding: 40px 0;
  color: var(--color-text-secondary);
  font-style: italic;
}

@media (max-width: 768px) {
  .forum-layout {
    flex-direction: column;
  }

  .main-column,
  .side-column {
    width: 100%;
  }

  .side-column {
    margin-top: 20px;
  }
}
</style>